export const release = '0404378500edd3a4cbbf6ca2b7371ae72ea7cf64';
